export default __webpack_public_path__ + "static/media/meta_image.e14098a9.png";